import React from "react";
import { sports, tvArti1 } from "../images/image";
import { ShortDate } from "./smComponents/ShortDate";
import { tvData } from "../constants";
import { ViewMoreButton } from "./smComponents/ViewMoreButton";
import { TvHero } from "./smComponents/TvHero";
import PropTypes from "prop-types";

export const TvSection = ({ isPrimerEquipo }) => {
  return (
    <div className="tv-section-bg max-width">
      <div className="mw-ct">
        <div className="tv-navbar">
          <div className="tv-logo">
            <h2>PSG TV</h2>
          </div>
          <div className="tv-navbar-left">
            <p>HIGHLIGHT 10MN</p>
            <p>PARTIDO INTEGRO</p>
            <p>THIS IS PARIS</p>
          </div>
          <div className="tv-navbar-right">
            <p>PATROCINADO POR</p>
            <img src={sports} alt="" />
          </div>
        </div>

        {/* big article */}
        <div className="wr-cg-2">
          <div className="tv-big-article-left">
            <img src={tvArti1} alt="frad" />
          </div>
          <div className="big-article-right">
            <ShortDate isPrimerEquipo={!isPrimerEquipo} />
            <h1>El golazo de Vitinha fren al Lens</h1>
          </div>
        </div>

        <div className="wr-cg-4 cg-4">
          {tvData.map(({ id, title, isPrimerEquipo }) => {
            return (
              <div key={id}>
                <div className="cgi-4-tv">
                  <span className={`arti${id}`}></span>
                </div>
                <div>
                  <ShortDate isPrimerEquipo={isPrimerEquipo} />
                  <h3 className="article-heading">{title}</h3>
                </div>
              </div>
            );
          })}
        </div>

        <ViewMoreButton />
        <TvHero />
       <div>
       {/* <iframe style={{border: '1px solid rgba(0, 0, 0, 0.1)'}} width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F1QfsFqJ8wLeuCA1NyZa7S6%2FGradients%3Ftype%3Ddesign%26mode%3Ddesign%26t%3DxGlUsHSix4dIff0w-1" allowfullscreen></iframe> */}
       </div>
      </div>
    </div>
  );
};
TvSection.propTypes = {
  isPrimerEquipo: PropTypes.bool.isRequired,
  tvData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      isPrimerEquipo: PropTypes.bool.isRequired,
    })
  ),
};
